<ion-list>
  <div *ngFor="let option of options" (click)="optionClicked(option)" class="option-line">
    <ion-checkbox [checked]="option.isSelected"></ion-checkbox>
    <span class="option-label">{{ option.label }}</span>
    <ion-icon *ngIf="option.isSelected" name="checkmark"></ion-icon>
  </div>
</ion-list>
